<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form>
            <div class="basic-title"><em>面试官信息</em></div>
            <div class="interview-wrap">
              面试官姓名：
              <el-input
                class="jm-input175"
                v-model="searchData.name"/>
              <el-button
                type="primary"
                @click="sendForm">查询</el-button>
            </div>
          </el-form>
          <jm-tableList
            url="/interview/inform/interviewInform"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="280">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'relationSchool', params: { userid: scope.row.userid } }"
                >
                  <el-button
                    size="mini"
                    type="primary"
                  >关联学校</el-button>
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .button{
    margin: 30px;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      searchData: {
        name: '',
      },
      refresh: false,
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
  },
  methods: {
    // 表单提交
    sendForm() {
      this.refresh = true;
    }
  },
};
</script>

